import React from "react";
import {useTranslation} from "react-i18next";
import {AgoraSubscriber} from "../../services/AgoraService";
import {AuctionsManager} from "@nextlot/core/webcast";
import {PlayerStatesEnum, MEDIA_VIDEO_CONTAINER_HTML_ELEMENT_ID} from "../bidder/BidderMediaStreamingRootCmp";



export default function ViewerEmbeddedMediaStreamingRootCmp() {

    const { t, i18n } = useTranslation();

    const refAgoraSubscriber = React.useRef<AgoraSubscriber>(null);

    const [playerState, setPlayerState] = React.useState<PlayerStatesEnum>(PlayerStatesEnum.connecting);
    const [isPlayButtonPressed, setPlayButtonPressed] = React.useState(false);
    const [isAudioVolumeOn, setAudioVolumeOn] = React.useState(true);

    React.useEffect(() => {
        refAgoraSubscriber.current = new AgoraSubscriber(AuctionsManager.currentWebcastAuctionHandler);
        const agoraSubscriber = refAgoraSubscriber.current;

        agoraSubscriber.connectAndJoinChannel().then(() => {
            setPlayerState(PlayerStatesEnum.connected_ok);
        });
    }, []);




    const handleClick_PlayButton = () => {
        setPlayButtonPressed(true);

        refAgoraSubscriber.current.registerAutoSubscribeToMasterRemoteUsers((agoraSubscriber) => {


            if (agoraSubscriber.subscribedRemoteAudioTrack && !agoraSubscriber.subscribedRemoteAudioTrack.isPlaying) {
                agoraSubscriber.subscribedRemoteAudioTrack.play();
                // maintain the audio volume/mute state
                if (isAudioVolumeOn) {
                    agoraSubscriber.subscribedRemoteAudioTrack.setVolume(100);
                }
                else {
                    agoraSubscriber.subscribedRemoteAudioTrack.setVolume(0);
                }
            }

            if (agoraSubscriber.subscribedRemoteVideoTrack && !agoraSubscriber.subscribedRemoteVideoTrack.isPlaying) {
                agoraSubscriber.subscribedRemoteVideoTrack.play(MEDIA_VIDEO_CONTAINER_HTML_ELEMENT_ID, {fit: "contain"});
            }

            if (agoraSubscriber.subscribedRemoteAudioTrack && agoraSubscriber.subscribedRemoteVideoTrack) {
                setPlayerState(PlayerStatesEnum.playing_audio_video);
            }
            else if (agoraSubscriber.subscribedRemoteAudioTrack) {
                setPlayerState(PlayerStatesEnum.playing_audio_only);
            }
            else if (agoraSubscriber.subscribedRemoteVideoTrack) {
                setPlayerState(PlayerStatesEnum.playing_video_only);
            }
            else {
                // there are no subscribed tracks
                setPlayerState(PlayerStatesEnum.connected_ok);
            }
        });
    };


    const handleChange_checkboxAudioVolumeOn = (evt) => {
        const isAudioOnChecked = evt.currentTarget.checked;
        const remoteAudioTrack = refAgoraSubscriber.current.subscribedRemoteAudioTrack;
        if (remoteAudioTrack?.isPlaying) {
            if (isAudioOnChecked) {
                remoteAudioTrack.setVolume(100);
            }
            else {
                remoteAudioTrack.setVolume(0);
            }
        }

        setAudioVolumeOn(isAudioOnChecked);
    };


    let playTracks:{ hasAudio?: boolean, hasVideo?: boolean } = null;
    let playTracksLabel:string = null;
    switch (playerState) {
        case PlayerStatesEnum.playing_audio_only: {
            playTracks = { hasAudio: true };
            playTracksLabel = 'Audio only';
            break;
        }
        case PlayerStatesEnum.playing_video_only: {
            playTracks = { hasVideo: true };
            playTracksLabel = 'Video only';
            break;
        }
        case PlayerStatesEnum.playing_audio_video: {
            playTracks = { hasAudio: true, hasVideo: true };
            playTracksLabel = 'Audio + Video';
            break;
        }
    }



    return (
        <>
            <div className="bidder-media-streaming-outline">
                <div className="bidder-cmp bidder-cmp--media-streaming">
                    <div className='cmp__body'>
                        {
                            playerState === PlayerStatesEnum.error
                                ? <div className="p-2">
                                    <h5 className="text-danger">{t('mediaStreaming.failedConnection')}</h5>
                                </div>
                                : (playerState >= PlayerStatesEnum.connected_ok)
                                    ?  <>
                                        <div className="media-video-container" id={MEDIA_VIDEO_CONTAINER_HTML_ELEMENT_ID} />
                                        {
                                            (isPlayButtonPressed)
                                                ? (
                                                    (!playTracks)
                                                    &&
                                                    <div className="media-controls-container">
                                                        <div className='p-2 text-light text-bg-dark'>Live stream pending ... please wait</div>
                                                    </div>
                                                )
                                                : <div className="media-controls-container">
                                                    <button type="button" className='btn btn-lg btn-success' onClick={handleClick_PlayButton}>{t('mediaStreaming.playBtn')}</button>
                                                </div>
                                        }
                                    </>
                                    : <div className='p-2'>
                                        <span><i className="fa-regular fa-signal-stream text-body-secondary" /> &nbsp; {t('mediaStreaming.connecting')}</span>
                                    </div>

                        }
                    </div>

                    {
                        (playerState >= PlayerStatesEnum.connected_ok)
                        &&
                        <div className="cmp__footer">
                            <div>
                                <i className="fa-regular fa-signal-stream text-success"/>
                                &nbsp; {playerState > PlayerStatesEnum.connected_ok ? `${t('mediaStreaming.playing_live', 'Live')} (${playTracksLabel})` : t('mediaStreaming.connected', 'Connected')}
                            </div>

                            {
                                (playerState === PlayerStatesEnum.playing_audio_video || playerState === PlayerStatesEnum.playing_audio_only)
                                &&
                                <label>
                                    {
                                        isAudioVolumeOn
                                            ? <i className='fa-regular fa-volume-high fa-fw' />
                                            : <i className='fa-regular fa-volume-slash fa-fw' />
                                    }

                                    &nbsp;

                                    <input type='checkbox' value='volume_on'
                                           className='ms-1 form-check-input'
                                           checked={isAudioVolumeOn}
                                           onChange={handleChange_checkboxAudioVolumeOn}
                                    />
                                </label>
                            }
                        </div>
                    }

                </div>
            </div>
        </>
    )
}



// import * as React from 'react';
// import {AuctionsManager, TaggedLogger} from "@nextlot/bidding-jsclient-core";
// import {AgoraSubscriber} from "../../services/AgoraService";
// import type {MasterRemoteUsersTypeDef} from "../../services/AgoraService";
// import {Stream} from "agora-rtc-sdk";
// import Tooltip from 'rc-tooltip';
// import { withTranslation } from 'react-i18next';
//
//
// const _logger = TaggedLogger.get('EmbeddedViewerMediaStreamingRootCmp');
//
//
//
//
// type CmpState = {
//     statusMessage?: string,
//     connectStatus?: number,
//     streamsPlayState: ?string|boolean,
//     isMuted: ?boolean,
// };
//
//
// const CONNECT_STATUS_NOT_CONNECTED = 0;
// const CONNECT_STATUS_CONNECTING = 5;
// const CONNECT_STATUS_CONNECTED_OK = 9;
// const CONNECT_STATUS_CONNECT_ERROR = -1;
//
//
// const MEDIA_VIDEO_CONTAINER_HTML_ELEMENT_ID = 'media_video_container';
// const MEDIA_AUDIO_CONTAINER_HTML_ELEMENT_ID = 'media_audio_container';
//
//
// class ViewerEmbeddedMediaStreamingRootCmp extends React.Component<{}, CmpState> {
//
//     constructor(props) {
//         super(props);
//         _logger.debug('.constructor()', props);
//
//         const {streamingAgoraAppId, streamingAgoraChannelName, streamingAgoraToken} = AuctionsManager.currentWebcastAuctionHandler.auctionConnectData;
//
//         this.streamingAgoraChannelName = streamingAgoraChannelName;
//         this.streamingAgoraToken = streamingAgoraToken;
//
//         this.agoraSubscriberService = new AgoraSubscriber(streamingAgoraAppId);
//
//         this.refMediaContainerAudio = React.createRef();
//         this.refMediaContainerVideo = React.createRef();
//
//         this.audioRemoteUser = null;
//         this.videoRemoteUser = null;
//
//
//         this.state = {
//             statusMessage: null,
//             connectStatus: false,
//             streamsPlayState: null,
//             isMuted: false,
//         };
//     }
//
//
//
//     componentDidMount(): void {
//         this.setState({
//             connectStatus: CONNECT_STATUS_CONNECTING,
//             statusMessage: 'Connecting ...'
//         }, () => {
//
//             this._registerRemoteMasterStreamsChangeListener();
//
//             this.agoraSubscriberService.connectAndJoinChannel(this.streamingAgoraChannelName, this.streamingAgoraToken)
//                 .then(() => {
//                     this.setState({
//                         connectStatus: CONNECT_STATUS_CONNECTED_OK,
//                         statusMessage: null,
//                     });
//
//                 }, (reason) => {
//                     this.setState({
//                         connectStatus: CONNECT_STATUS_CONNECT_ERROR,
//                         statusMessage: reason.toString(),
//                     });
//
//                 });
//
//         });
//     }
//
//
//     _areCurrentStreamsTheSame():boolean {
//         return (this.audioStream && this.videoStream) &&
//             (this.audioStream.getId() === this.videoStream.getId());
//     }
//
//
//
//     _playVideo(isTriggeredByForcePlayButtonClick:?boolean):void {
//         const stream:Stream = this.videoStream;
//         const mixedStream = this._areCurrentStreamsTheSame();
//         const streamTypeLabel = (mixedStream ? 'mixed' : 'video');
//
//         // if it's only videoStream (not sameStream) then play muted
//         stream.play(MEDIA_VIDEO_CONTAINER_HTML_ELEMENT_ID, {fit: "contain", muted: (!mixedStream || this.state.isMuted)},
//             (playErr) => {
//                 if (playErr) {
//                     _logger.error('_playVideo:'+ streamTypeLabel +'['+ stream.getId() +']>stream.play FAILED:', playErr);
//
//                     if (isTriggeredByForcePlayButtonClick) {
//                         // human interaction required to with the browser to trigger the play of <video>
//                         const videoContainerEl = this.refMediaContainerVideo.current;
//                         if (videoContainerEl) {
//                             const videoNodes = videoContainerEl.getElementsByTagName('video');
//                             const vEl = videoNodes && videoNodes[0];
//                             vEl && vEl.play();
//                             return;
//                         }
//                     }
//                     else if (playErr.reason !== 'closed_stalled_auction') {
//                         // when `canplay`, then: https://docs.agora.io/en/Interactive%20Broadcast/API%20Reference/web/interfaces/agorartc.streamplayerror.html
//                         // use "Play media" button to approve play on all errors except for closed_stalled_auction that is handeld by Agora
//
//                         // we set the state to show the "Play media" button which will trigger the play again with `isTriggeredByForcePlayButtonClick = true`
//                         this.setState({
//                             streamsPlayState: 'canplay',
//                             statusMessage: '',
//                         });
//
//                         return;
//                     }
//
//                     this.setState({
//                         streamsPlayState: 'error',
//                         statusMessage: "Media["+ streamTypeLabel +"] play error: " + playErr.reason,
//                     })
//                 }
//                 else if (mixedStream || ( ! mixedStream && this.audioStream && this.audioStream.isPlaying())) {
//                     // if it's sameStream or audio is already playing, then set state to success
//                     this.setState({
//                         streamsPlayState: true,
//                         statusMessage: 'Live media',
//                     });
//
//                 }
//             });
//     }
//
//
//     _playAudio(isTriggeredByForcePlayButtonClick:?boolean):void {
//         const stream:Stream = this.audioStream;
//
//         stream.play(MEDIA_AUDIO_CONTAINER_HTML_ELEMENT_ID, { muted: this.state.isMuted },
//             (playErr) => {
//                 if (playErr) {
//                     _logger.error('_playAudio:audio['+ stream.getId() +']>stream.play FAILED:', playErr);
//
//                     if (isTriggeredByForcePlayButtonClick) {
//                         // human interaction required to with the browser to trigger the play of <video>
//                         const videoContainerEl = this.refMediaContainerAudio.current;
//                         if (videoContainerEl) {
//                             const videoNodes = videoContainerEl.getElementsByTagName('video');
//                             const vEl = videoNodes && videoNodes[0];
//                             vEl && vEl.play();
//                             return;
//                         }
//                     }
//                     else if (playErr.reason !== 'closed_stalled_auction') {
//                         // when `canplay`, then: https://docs.agora.io/en/Interactive%20Broadcast/API%20Reference/web/interfaces/agorartc.streamplayerror.html
//                         // use "Play media" button to approve play on all errors except for closed_stalled_auction that is handeld by Agora
//
//                         // we set the state to show the "Play media" button which will trigger the play again with `isTriggeredByForcePlayButtonClick = true`
//                         this.setState({
//                             streamsPlayState: 'canplay',
//                             statusMessage: '',
//                         });
//
//                         return;
//                     }
//
//
//                     // if we reach this point => ERROR
//
//                     this.setState({
//                         streamsPlayState: 'error',
//                         statusMessage: "Media[audio] play error: " + playErr.reason,
//                     })
//                 }
//                 else if (!this.videoStream || this.videoStream.isPlaying()) {
//                     // if there's no videoStream, or it is already playing, then set state to success
//                     this.setState({
//                         streamsPlayState: true,
//                         statusMessage: 'Live media',
//                     });
//
//                 }
//             });
//     }
//
//
//
//     _registerRemoteMasterStreamsChangeListener() {
//
//         this.agoraSubscriberService.onRemoteMasterStreamsChanged((change: MasterRemoteUsersTypeDef) => {
//
//             const currentStreamsAreTheSame = this._areCurrentStreamsTheSame();
//
//             // stop playing and unsubscribe all current streams
//             if (this.videoStream) {
//                 this.videoStream.stop();
//                 this.agoraSubscriberService.unsubscribe(this.videoStream);
//             }
//
//             if (this.audioStream && !currentStreamsAreTheSame) {
//                 this.audioStream.stop();
//                 this.agoraSubscriberService.unsubscribe(this.audioStream);
//             }
//
//
//             this.setState({
//                 streamsPlayState: null,
//             }, () => {
//
//                 this.audioStream = change.audioRemoteUser;
//                 this.videoStream = change.videoRemoteUser;
//
//                 // DEBUG
//                 window._dev_agora_audioStream = this.audioStream;
//                 window._dev_agora_videoStream = this.videoStream;
//
//
//                 if (!this.audioStream && !this.videoStream) {
//                     this.setState({
//                         streamsPlayState: null,
//                         statusMessage: 'Media not available',
//                     });
//
//                     return;
//                 }
//
//
//                 const mixedStream = this._areCurrentStreamsTheSame();
//
//                 if (this.videoStream || mixedStream) {
//
//                     const streamTypeLabel = (mixedStream ? 'mixed' : 'video');
//
//                     this.agoraSubscriberService.subscribe(this.videoStream)
//                         .then((stream) => {
//                             _logger.debug('_registerRemoteMasterStreamsChangeListener>onRemoteMasterStreamsChanged>' + streamTypeLabel + '[' + stream.getId() + ']>subscribe.then streamId:', stream.getId());
//
//                             this.videoStream = stream;
//
//                             this._playVideo();
//
//                         }, (reason) => {
//                             this.setState({
//                                 streamsPlayState: 'error',
//                                 statusMessage: 'Media['+ streamTypeLabel +'] subscribe error: ' +  reason,
//                             })
//                         });
//
//
//                 }
//
//                 if (this.audioStream && ! mixedStream) {
//
//                     this.agoraSubscriberService.subscribe(this.audioStream)
//                         .then((stream) => {
//
//                             _logger.debug('_registerRemoteMasterStreamsChangeListener>onRemoteMasterStreamsChanged>audioStream>subscribe.then streamId:', stream.getId());
//
//                             this.audioStream = stream;
//
//                             this._playAudio();
//
//                         }, (reason) => {
//                             this.setState({
//                                 streamsPlayState: 'error',
//                                 statusMessage: "Media[audio] subscribe error: " + reason,
//                             })
//                         });
//                 }
//
//             });
//
//         });
//     }
//
//
//     handleClick_PlayButton = (evt) => {
//         const mixedStream = this._areCurrentStreamsTheSame();
//
//         let shouldPlayAudio:boolean = false;
//         let shouldPlayVideo:boolean = false;
//
//         if (this.audioStream && ! mixedStream) {
//             this.audioStream.stop();
//             shouldPlayAudio = true;
//         }
//
//         if (this.videoStream || mixedStream) {
//             this.videoStream.stop();
//             shouldPlayVideo = true;
//         }
//
//
//         if (shouldPlayAudio || shouldPlayVideo) {
//             this.setState({
//                 streamsPlayState: true,
//                 statusMessage: 'Live media',
//             }, () => {
//                 setTimeout(() => {
//                     if (shouldPlayAudio) {
//                         this._playAudio(true);
//                     }
//                     if (shouldPlayVideo) {
//                         this._playVideo(true);
//                     }
//                 }, 100);
//             });
//         }
//         else {
//             this.setState({
//                 streamsPlayState: '',
//                 statusMessage: 'Missing live media',
//             })
//         }
//     };
//
//
//     handleClick_MuteButton = (evt) => {
//         const currentMuted:boolean = this.state.isMuted;
//         const newMuted:boolean = !currentMuted;
//         const mixedStream = this._areCurrentStreamsTheSame();
//
//         this.setState({
//             isMuted: null,
//         }, () => {
//             if (this.audioStream) {
//                 newMuted
//                     ? this.audioStream.muteAudio()
//                     : this.audioStream.unmuteAudio()
//             }
//             else if (mixedStream) {
//                 newMuted
//                     ? this.videoStream.muteAudio()
//                     : this.videoStream.unmuteAudio()
//             }
//
//             this.setState({
//                 isMuted: newMuted
//             })
//         });
//     };
//
//
//     renderMediaBodyContent(t) {
//         if (this.state.connectStatus === CONNECT_STATUS_CONNECT_ERROR) {
//             return (
//                 <div className="p-2">
//                     <h5 className="text-danger">{t('mediaStreaming.failedConnection')}</h5>
//                     <p>{this.state.statusMessage}</p>
//                 </div>
//             )
//         }
//
//         if (this.state.connectStatus === CONNECT_STATUS_CONNECTED_OK) {
//             return (
//                 <>
//                     <div className="media-audio-container" id={MEDIA_AUDIO_CONTAINER_HTML_ELEMENT_ID} ref={this.refMediaContainerAudio} />
//                     <div className="media-video-container" id={MEDIA_VIDEO_CONTAINER_HTML_ELEMENT_ID} ref={this.refMediaContainerVideo} />
//                     {
//                         this.state.streamsPlayState === 'canplay'
//                         && <div className="media-controls-container">
//                             <button
//                                 type="button"
//                                 className='btn btn-lg btn-success'
//                                 onClick={this.handleClick_PlayButton}
//                             >{t('mediaStreaming.playBtn')}</button>
//                         </div>
//                     }
//                 </>
//             )
//         }
//
//         return (
//             <div className='p-2'>
//                 <span><i className="fa-regular fa-signal-stream" /> &nbsp; {t('mediaStreaming.connecting')}</span>
//             </div>
//         )
//     }
//
//
//     renderFooterControlsWidget(t) {
//         if (this.state.isMuted === null) {
//             return <button type="button" className='btn btn-sm btn-dark' disabled={true}>...</button>
//         }
//
//         if (this.state.isMuted) {
//             return <button type="button" className='btn btn-sm btn-outline-dark' onClick={this.handleClick_MuteButton}>
//                 <i className="fa-regular fa-volume-slash"/> {t('mediaStreaming.unmute')}</button>
//         }
//         else {
//             return <button type="button" className='btn btn-sm btn-outline-dark' onClick={this.handleClick_MuteButton}>
//                 <i className="fa-regular fa-volume"/> {t('mediaStreaming.mute')}</button>
//         }
//     }
//
//
//     render(): void {
//         _logger.debug('.render() state: ', this.state);
//         const { t } = this.props;
//
//         return (
//             <div className="bidder-media-streaming-outline">
//                 <div className="bidder-cmp bidder-cmp--media-streaming">
//                     <div className='cmp__body'>
//                         {this.renderMediaBodyContent(t)}
//                     </div>
//
//                     {
//                         this.state.connectStatus === CONNECT_STATUS_CONNECTED_OK &&
//                         <div className="cmp__footer">
//                             <div>
//                                 <Tooltip overlay={<span dangerouslySetInnerHTML={{__html: t('mediaStreaming.tooltip')}}></span>} placement='right'>
//                                     <i className="fa-regular fa-signal-stream" />
//                                 </Tooltip>
//                             </div>
//
//                             {this.renderFooterControlsWidget(t)}
//                         </div>
//                     }
//                 </div>
//             </div>
//         );
//     }
//
// }
//
// export default withTranslation()(ViewerEmbeddedMediaStreamingRootCmp);
//
